var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#1E8DCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7C11.4758 7 7 11.5161 7 17C7 22.5242 11.4758 27 17 27C22.4839 27 27 22.5242 27 17C27 11.5161 22.4839 7 17 7ZM17 11.4355C17.9274 11.4355 18.6935 12.2016 18.6935 13.129C18.6935 14.0968 17.9274 14.8226 17 14.8226C16.0323 14.8226 15.3065 14.0968 15.3065 13.129C15.3065 12.2016 16.0323 11.4355 17 11.4355ZM19.2581 21.6774C19.2581 21.9597 19.0161 22.1613 18.7742 22.1613H15.2258C14.9435 22.1613 14.7419 21.9597 14.7419 21.6774V20.7097C14.7419 20.4677 14.9435 20.2258 15.2258 20.2258H15.7097V17.6452H15.2258C14.9435 17.6452 14.7419 17.4435 14.7419 17.1613V16.1935C14.7419 15.9516 14.9435 15.7097 15.2258 15.7097H17.8065C18.0484 15.7097 18.2903 15.9516 18.2903 16.1935V20.2258H18.7742C19.0161 20.2258 19.2581 20.4677 19.2581 20.7097V21.6774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a8027faf855756c917a8d334edf3c918.svg";
export { ForwardRef as ReactComponent };